import {
  CreatedEnrollmentToken,
  EnrollmentTokenDetail,
  EnrollmentTokenSummary,
  type CreateEnrollmentTokenRequest,
} from '@bartizo/shared';
import { apiPageRequest, apiRequest, type Page } from './client.js';

/**
 * Enrollment tokens (knowledge doc section 10, method A).
 *
 * `create` is the only call that ever returns the token itself. Nothing here
 * stores it — the page that shows it holds it in component state and loses it on
 * the next navigation, which is what "shown once" means.
 */

export interface TokenFilters {
  activeOnly?: boolean;
  limit?: number;
  cursor?: string;
}

const toQueryString = (filters: TokenFilters): string => {
  const params = new URLSearchParams();
  if (filters.activeOnly === true) params.set('active_only', 'true');
  if (filters.limit !== undefined) params.set('limit', String(filters.limit));
  if (filters.cursor !== undefined) params.set('cursor', filters.cursor);
  const query = params.toString();
  return query.length > 0 ? `?${query}` : '';
};

export const listEnrollmentTokens = (
  filters: TokenFilters = {},
): Promise<Page<EnrollmentTokenSummary>> =>
  apiPageRequest(`/enrollment-tokens${toQueryString(filters)}`, {
    schema: EnrollmentTokenSummary,
  });

export const getEnrollmentToken = (id: string): Promise<EnrollmentTokenDetail> =>
  apiRequest(`/enrollment-tokens/${encodeURIComponent(id)}`, { schema: EnrollmentTokenDetail });

export const createEnrollmentToken = (
  body: CreateEnrollmentTokenRequest,
): Promise<CreatedEnrollmentToken> =>
  apiRequest('/enrollment-tokens', { method: 'POST', body, schema: CreatedEnrollmentToken });

export const revokeEnrollmentToken = (id: string): Promise<EnrollmentTokenSummary> =>
  apiRequest(`/enrollment-tokens/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    schema: EnrollmentTokenSummary,
  });
